import { NineSliceSprite, Texture } from 'pixi.js';

export default class NinePatch extends NineSliceSprite {
  constructor(
    img: string | Texture,
    leftWidth: number,
    topHeight: number,
    rightWidth: number,
    bottomHeight: number,
  ) {
    const texture = typeof img === 'string' ? Texture.from(img) : img;
    super({
      texture,
      leftWidth,
      topHeight,
      rightWidth,
      bottomHeight,
    });
  }
}
